import React, { useState } from 'react';
import { FestivalForm, FestivalTable } from './';
import { FestivalHeader, Loading } from '../controls';
import Portal from '../modal';
import { useFestivalsQuery } from '../../queries/festivals';

export function Festivals() {
  const [showModal, setShowModal] = useState(false);
  const { data: festivals = [], isPending, isError } = useFestivalsQuery();

  const addNewFestival = (e) => {
    e?.preventDefault();
    setShowModal(true);
  };

  if (isPending) {
    return <Loading />;
  }

  if (isError) {
    return (
      <div className="mt-16 text-center text-red-600">
        Could not load festivals. Try refreshing the page.
      </div>
    );
  }

  return (
    <>
      <FestivalHeader
        variant="bethere"
        title="My Events"
        showAdd
        addTitle="Create New Event"
        addAction={addNewFestival}
      />
      <FestivalTable festivals={festivals} />

      <Portal
        header="Add New Festival"
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <FestivalForm />
      </Portal>
    </>
  );
}
